import { Redis } from "@upstash/redis"

const url = process.env.NEXT_PUBLIC_UPSTASH_REDIS_URL
// Server-only token (never NEXT_PUBLIC_: Next inlines those into client bundles).
const token = process.env.UPSTASH_REDIS_REST_TOKEN

// Validate URL before creating client (server only: browsers never get the token)
if ((!url || !token) && typeof window === "undefined") {
    console.error(`[Redis] Missing env vars - URL: ${url ? "set" : "MISSING"}, TOKEN: ${token ? "set" : "MISSING"}`)
}

// Validate URL format
let validatedUrl = url
if (url) {
    try {
        new URL(url)
    } catch (e) {
        console.error(`[Redis] Invalid URL format: "${url?.substring(0, 50)}..."`)
        validatedUrl = undefined
    }
}

const redisClient = validatedUrl && token
    ? new Redis({ url: validatedUrl, token })
    : {
          // Fallback no-op client when Redis is unavailable
          get: async () => null,
          set: async () => null,
          setex: async () => null,
          del: async () => null,
          expire: async () => null,
          scan: async () => [0, []],
          keys: async () => [],
          sadd: async () => 0,
          scard: async () => 0,
          exists: async () => 0
      } as any

export { redisClient }
